// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"az_w9","azLogo":"az_x9","azLogoMedium":"az_y9"};